import { useTheme } from '@mui/material/styles';

import { Typography, Grid } from '@mui/material';
import Logo from './LogoImage';
import PropTypes from 'prop-types';

const LoginLogo = ({ setCenter = false, color = '' }) => {
    const theme = useTheme();
    return (
        <Grid container>
            <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" gap={1}>
                <Logo width="19%" color={color} />
                <Grid container display="block" sx={{ width: setCenter === true ? 'auto' : '100%' }}>
                    <Grid item>
                        <Typography
                            variant="h6"
                            sx={{ fontFamily: 'URW DIN BOLD', mt: 0.8, textDecoration: 'none', color: theme.palette.primary.main }}
                        >
                            RPL
                        </Typography>
                    </Grid>
                    <Grid item sx={{ marginTop: '-5px' }}>
                        <Typography
                            variant="h3"
                            sx={{ fontFamily: 'URW DIN BOLD', textDecoration: 'none', color: theme.palette.primary.main }}
                        >
                            ROBOT
                        </Typography>
                    </Grid>
                    <Grid item sx={{ marginTop: '-5px' }}>
                        <Typography
                            variant="h2"
                            sx={{ fontFamily: 'URW DIN BOLD', textDecoration: 'none', color: theme.palette.primary.main }}
                        >
                            DASH
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
LoginLogo.propTypes = {
    setCenter: PropTypes.bool,
    color: PropTypes.string
};

export default LoginLogo;
